import { Flex, Modal } from "@wayflyer/flyui";
import { RhfDropdownField } from "@wayflyer/flyui-hook-form";
import { useIntl } from "react-intl";

import type { useBankControllerContext } from "../../hooks/bank-controller-context";
import { MESSAGES } from "../message-definitions";

type ConnectModalProps = Pick<
  ReturnType<typeof useBankControllerContext>,
  "countryForm" | "countryOptions" | "defaultCountry" | "isConnectionUnsupportedCountry" | "isConnecting" | "ready"
> & {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export const ConnectModal = ({
  isOpen,
  onClose,
  onContinue,
  countryForm,
  countryOptions,
  defaultCountry,
  isConnectionUnsupportedCountry,
  isConnecting,
  ready,
}: ConnectModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage(MESSAGES.connectModalTitle)}
      primaryAction={{
        content: intl.formatMessage(MESSAGES.connectModalContinue),
        onAction: onContinue,
        // Basiq's connect kicks off an async token-fetch-then-redirect chain after isConnecting
        // has already flipped back to false - ready (~launchingBasiq) covers that whole window.
        loading: !ready || isConnecting,
        disabled: isConnectionUnsupportedCountry,
      }}
    >
      <Flex direction="column" gap="4">
        <RhfDropdownField
          name="country"
          initialValue={defaultCountry?.code}
          options={countryOptions}
          form={countryForm}
          label={intl.formatMessage(MESSAGES.bankLocationLabel)}
        />
      </Flex>
    </Modal>
  );
};
